import { TOffer } from '../types/offer';

export enum FDealType {
  Unexpected = 0, // Do not use
  Sale = 1 << 0,
  RentLongterm = 1 << 1,
  RentDaily = 1 << 2,
  Rent = RentLongterm | RentDaily,
  Any = Sale | Rent,
}

export function getDealType(offer: TOffer): FDealType {
  const category = offer.category.toLowerCase();

  if (category.indexOf('daily') >= 0) {
    return FDealType.RentDaily;
  } else if (category.indexOf('rent') >= 0) {
    return FDealType.RentLongterm;
  } else if (category.indexOf('sale') >= 0) {
    return FDealType.Sale;
  }

  return FDealType.Unexpected;
}
